module.exports = __webpack_public_path__ + "static/img/7.5b740cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7.png
// module id = DBM3
// module chunks = 1